export const environment = {
  production: true,
  apiHost: 'https://uthkal.com/uat/rista/api/index.php/v1/',
  webHost: 'https://uthkal.com/ristaweb',
  imgUrl:  'https://uthkal.com/uat/rista',
  showStudent: true,
  sessionPrefix: 'rista_',
  version: '6.6.23',
};
